import React, { useState, useMemo, useEffect, useReducer, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment-timezone";
import { Select, FormControl, Divider, CircularProgress, InputAdornment } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Tooltip from '@mui/material/Tooltip';
import MaterialReactTable from 'material-react-table';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import RefreshIcon from '@mui/icons-material/Refresh';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import Chip from '@mui/material/Chip';
import borders from "assets/mavric-theme/base/borders";
import Autocomplete from '@mui/material/Autocomplete';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTheme } from '@mui/material/styles';
import { downloadDataConsumptionReport, getCustomers, getDataconsumptionReportTypes, getDataConsumptionView } from "apis/CustomersApis";
import { logout } from "actions/auth";
const { primary, secondary, text, tableRow, transparent } = colors;
const { size } = typography;
const { borderRadius } = borders;
const ITEM_HEIGHT = 48;


export default function DataConsumptionView() {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // const columns = useMemo(() => [
  //   {
  //     accessorKey: 'customer_id',
  //     header: 'Customer ID',
  //     size: 120,
  //     Filter: ({ header }) => (
  //       <Autocomplete
  //         size="small"
  //         options={customerIdOptions}
  //         disableCloseOnSelect
  //         getOptionLabel={(option) => option}
  //         renderOption={(props, option, { selected }) => (
  //           <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
  //         )}
  //         style={{ width: 150 }}
  //         renderInput={(params) => (
  //           <TextField {...params} variant="outlined" placeholder="Customer ID" />
  //         )}
  //         sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
  //         onChange={(event, value) =>
  //           header.column.setFilterValue(value)}
  //         clearIcon={<HighlightOffIcon fontSize="small" />}
  //         ListboxProps={{
  //           sx: {
  //             maxHeight: ITEM_HEIGHT * 4.5,
  //           }
  //         }}
  //       />
  //     ),
  //     filterFn: 'customerIdFilterFn',
  //     enableColumnFilter: false,
  //   },
  //   {
  //     header: 'Customer Name',
  //     accessorKey: 'org_name',
  //     filter: 'equals',
  //     id: 'org_name',
  //     size: 150,
  //     Filter: ({ header }) => (
  //       <Autocomplete
  //         size="small"
  //         options={orgNameOptions}
  //         disableCloseOnSelect
  //         getOptionLabel={(option) => option}
  //         renderOption={(props, option, { selected }) => (
  //           <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
  //         )}
  //         style={{ width: 165 }}
  //         renderInput={(params) => (
  //           <TextField {...params} variant="outlined" placeholder="Customer Name" />
  //         )}
  //         sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
  //         onChange={(event, value) =>
  //           header.column.setFilterValue(value)}
  //         clearIcon={<HighlightOffIcon fontSize="small" />}
  //         ListboxProps={{
  //           sx: {
  //             maxHeight: ITEM_HEIGHT * 4.5,
  //           }
  //         }}
  //       />
  //     ),
  //     filterFn: 'customerNameFilterFn',

  //   },
  //   {
  //     accessorKey: 'pretty_publisher_bytes_transferred',
  //     header: 'Probe Data',
  //     size: 150,
  //     enableColumnFilter: false,
  //   },
  //   {
  //     accessorKey: 'pretty_viewer_bytes_transferred',
  //     header: 'Viewers Data',
  //     size: 150,
  //     enableColumnFilter: false,
  //   },
  //   {
  //     accessorKey: 'pretty_total_bytes_transferred',
  //     header: 'Total Data',
  //     size: 150,
  //     enableColumnFilter: false,
  //   },
  //   {
  //     accessorKey: 'first_activity_on',
  //     header: 'First Event On',
  //     size: 180,
  //     enableColumnFilter: false,
  //     Cell: ({ cell }) => {
  //       const date = cell.getValue();
  //       return date ? moment.utc(date).tz(userTimeZone).format("YYYY-MM-DD HH:mm:ss A") : '-';
  //     },
  //   },
  //   {
  //     accessorKey: 'last_activity_on',
  //     header: 'Last Event On',
  //     size: 180,
  //     enableColumnFilter: false,
  //     Cell: ({ cell }) => {
  //       const date = cell.getValue();
  //       return date ? moment.utc(date).tz(userTimeZone).format("YYYY-MM-DD HH:mm:ss A") : '-';
  //     },
  //   },
  //   {
  //     accessorKey: 'probe_serial_numbers',
  //     header: 'Probe Serial Numbers',
  //     size: 250,
  //     enableColumnFilter: false,
  //     Cell: ({ cell }) => {
  //       const [expanded, setExpanded] = useState(false);
  //       const probes = cell.getValue();
  //       // console.log("probes:", probes);
  //       if (!probes || probes.length === 0) return '-';

        
  //       const probesCount = probes.length;
  //       const visibleProbes = expanded ? probes : [];

  //       return (
  //         <Box
  //           sx={{
  //             display: 'flex',
  //             gap: 0.5,
  //             flexWrap: 'wrap',
  //             alignItems: 'center',
  //           }}
  //         >

  //           {expanded &&
  //             visibleProbes.map((serial, index) => (
  //               <Chip
  //                 key={index}
  //                 label={serial}
  //                 size="small"
  //                 variant="outlined"
  //                 sx={{
  //                   fontSize: '13px',
  //                   fontWeight: 600,
  //                 }}
  //               />
  //             ))}

  //           {!expanded ? (
  //             <Box
  //               onClick={() => setExpanded(true)}
  //               sx={{
  //                 color: '#007BCE',
  //                 fontWeight: 600,
  //                 fontSize: '14px',
  //                 cursor: 'pointer',
  //               }}
  //             >
  //               +{probesCount}
  //             </Box>
  //           ) : (
  //             <Box
  //               onClick={() => setExpanded(false)}
  //               sx={{
  //                 color: '#D32F2F',
  //                 fontWeight: 600,
  //                 fontSize: '16px',
  //                 cursor: 'pointer',
  //                 marginLeft: '4px',
  //               }}
  //             >
  //               -
  //             </Box>
  //           )}
  //         </Box>
  //       );
  //     },


  //   },
  // ], []);

  const dispatchs = useDispatch();
  const history = useHistory();
  const MyStateRole = useSelector(state => state.role);
  const UserId = useSelector(state => state.userid);
  const RoleId = useSelector(state => state.roleId);
  const Token = useSelector(state => state.accessToken);
  const isAccounting = (MyStateRole === "accounting") ? true : false;
  const isSalesOperator = (MyStateRole === "salesoperator") ? true : false;
  const isSalesAdmin = (MyStateRole === "salesadmin") ? true : false;
  const isSupport = (MyStateRole === "support") ? true : false;
  const isDealerAdmin = (MyStateRole === "dealeradmin") ? true : false;
  const isDealerOperator = (MyStateRole === "dealeroperator") ? true : false;
  const UserFirstName = useSelector(state => state.firstName);
  const [loading, setLoading] = useState(false);
  const [reportTypes, setReportTypes] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const [displayedView, setDisplayedView] = useState('thismonth');
  const [DataConsumptionList, setDataConsumptionList] = useState([]);
  const [currentView, setCurrentView] = useState('thismonth');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [custDataList, setCustDataList] = useState([]);
  const [downloadDialog, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case "SET_FILENAME":
        return { ...state, filename: action.payload };
      case "SET_OPEN":
        return { ...state, open: action.payload };
      case "SET_BLOB":
        return { ...state, blob: action.payload };
      case "RESET":
        return { filename: "default", open: false, blob: null };
      default:
        return state;
    }
  }, {
    filename: "default",
    open: false,
    blob: null
  });
  const [timezone, setTimezone] = useState(userTimeZone);
  const [orgNameOptions, setOrgNameOptions] = useState([]);
  const [customerIdOptions, setCustomerIdOptions] = useState([]);
  const [probeViewerInfo, setProbeViewerInfo] = useState(null);
  const [probeStreamingInfo, setProbeStreamingInfo] = useState(null);
  const [dataConsumptionInfo, setDataConsumptionInfo] = useState(null);

  const getDisplayLabel = (value) => {
    const labels = {
      'thismonth': 'This Month',
      'lastmonth': 'Last Month',
      'all': 'All'
    };
    return labels[value] || value;
  };


  const getCustomerData = () => {
    return new Promise(function (resolve, reject) {
      getCustomers().then((response) => { setCustDataList(response); resolve(response); })
      .catch((error) => { setCustDataList([]); let errMessage = '';
        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          console.log(error.request);
        } else {
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };

  // useEffect(() => {
  //   if (custDataList.length > 0) {
  //     const defaultCustomer = custDataList[0];
  //     setSelectedCustomer(defaultCustomer);
  //     // fetchData(currentView, defaultCustomer.customer_id);
  //     if (defaultCustomer && defaultCustomer.customer_id) {
  //       fetchDataConsumptionViewData(defaultCustomer.customer_id, currentView);
  //     }
  //   }
  // }, [custDataList]);


  const handleCustomerChange = async (e) => {
    const selectedOrgName = e.target.value;

    if(!selectedOrgName) {
      // User selected "Select Customer"
      setSelectedCustomer(null);         // Clear selected customer
      setDataConsumptionList([]);        // Clear data list
      setProbeViewerInfo(null);          // Clear probe viewer info
      setProbeStreamingInfo(null);       // Clear probe streaming info
      setDataConsumptionInfo(null);      // Clear consumption info
      return;
    }
    const selectedCustomer = custDataList.find(customer => customer.org_name === selectedOrgName);

    if (selectedCustomer) {
      setSelectedCustomer(selectedCustomer);
      await fetchDataConsumptionViewData(selectedCustomer.customer_id, currentView);
    } else console.log("Invalid customerId : ", selectedCustomer.customer_id);
  };

  const fetchReportTypesData = async () => {
    setLoading(true);
    try {
      const response = await getDataconsumptionReportTypes();
      // console.log("Data loaded:", response);
      const types = response && response.report_types
      const formattedTypes = types.map(type => ({
        value: type,
        label: type === 'thismonth' ? 'This Month' :
          type === 'lastmonth' ? 'Last Month' :
            type === 'all' ? 'All' : type
      }));
      setReportTypes(types);

    } catch (error) {
      console.error('Error:', error);
      setReportTypes([]);
    } finally {
    }
  };

  // const fetchData = async (view = currentView) => {
  //   setLoading(true);
  //   setError(null);
  //   try {
  //     const params = {
  //       query_timezone: timezone,
  //       duration: view
  //     };

  //     const result = await getDataConsumptionView(params);
  //     setData(result || []);
  //     setCurrentView(view);
  //   } catch (err) {
  //     setError(err);
  //     setData([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
  }, [loading, dataConsumptionInfo, DataConsumptionList]);

  const getProbeStreamingFileName = (period) => {
    const date = new Date();
    const year = date.getFullYear();

    if (period === 'all') {
      return `MX_DataConsumption_Report_${year}.xlsx`;
    } else {
      if (period === 'lastmonth') {
        date.setMonth(date.getMonth() - 1);
      }

      const monthName = date.toLocaleString('default', { month: 'short' });
      const monthYear = date.getFullYear();

      return `MX_DataConsumption_Report_${monthName}_${monthYear}.xlsx`;
    }
  };

  const fetchDataConsumptionViewData = async (customerId, view) => {
    const period = view || currentView;
    const custId = customerId || selectedCustomer.customer_id;
    const selectedPeriod = view || currentView;

    if (!selectedPeriod || !custId) {
      console.warn("Missing period or customer ID", { selectedPeriod, custId });
      return;
    }

    setLoading(true);
    try {
      const periodMap = {
        thismonth: "thismonth",
        lastmonth: "lastmonth",
        all: "all",
      };

      const duration = periodMap[selectedPeriod] || "thismonth";

      const params = {
        query_timezone: timezone,
        duration,
      };

      const response = await getDataConsumptionView(custId, params);
      // console.log("API Response:", response);

      if (!response) {
        setDataConsumptionList([]);
        setProbeViewerInfo(null);
        setProbeStreamingInfo(null);
        setDataConsumptionInfo(null);
        return;
      }

      setProbeViewerInfo(response.probe_viewer_info || null);
      setProbeStreamingInfo(response.probe_streaming_info || null);
      setDataConsumptionInfo(response.data_consumption_info || null);
      setDisplayedView(selectedPeriod);

      if (response.data_consumption_info) {
        setDataConsumptionList([response.data_consumption_info]);
      } else {
        setDataConsumptionList([]);
      }
      // console.log(`Fetched ${currentView} data:~bj`, dataList);
      // await new Promise(resolve => setTimeout(resolve, 100));
    } catch (error) {
      console.error('Error fetching data:', error);
      setDataConsumptionList([]);
      setProbeViewerInfo(null);
      setProbeStreamingInfo(null);
      setDataConsumptionInfo(null);
    } finally {
      setLoading(false);
    }
  };

  const downloadReport = async () => {
    if (!currentView) return;
    setDownloading(true);
    try {
      const periodMap = {
        'thismonth': 'thismonth',
        'lastmonth': 'lastmonth',
        'all': 'all'
      };
      // const response = await downloadProbeStreamingReport(period);
      // console.log('Download response:~bj', response);
      const period = periodMap[displayedView];
      const payload = {
        query_timezone: timezone,
        duration: period
      };
      const blob = await downloadDataConsumptionReport(payload, selectedCustomer.customer_id);
      const filename = getProbeStreamingFileName(period);
      // setDownloadDialog({ open: true, filename: defaultFilename, blob: blob });
      dispatch({ type: "SET_BLOB", payload: blob });
      dispatch({ type: "SET_FILENAME", payload: filename });
      dispatch({ type: "SET_OPEN", payload: true });

    } catch (error) {
      console.error('Download error:', error);
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    if (Array.isArray(DataConsumptionList) && DataConsumptionList.length > 0) {
      prepareCustomerData(DataConsumptionList);
    }
  }, [DataConsumptionList]);


  const prepareCustomerData = (data) => {

    let updtdOrgNameOptions = orgNameOptions;
    let updtdCustIdOptions = customerIdOptions;

    data.map(row => {
      const isDuplicateOrgName = updtdOrgNameOptions.includes(row.org_name);
      const isDuplicateCustId = updtdCustIdOptions.includes(row.customer_id)
      if (!isDuplicateOrgName) {
        updtdOrgNameOptions.push(row.org_name);
      }
      if (!isDuplicateCustId) {
        updtdCustIdOptions.push(String(row.customer_id));
      }
    });

    setOrgNameOptions(updtdOrgNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    setCustomerIdOptions(updtdCustIdOptions.sort(((a, b) => parseInt(a) - parseInt(b))));

  };

  const handleFilenameChange = useCallback((e) => dispatch({ type: "SET_FILENAME", payload: e.target.value }), []);

  const handleConfirmDownload = () => {
    console.log("handleConfirmDownload::", downloadDialog);
    if (downloadDialog.blob && downloadDialog.filename) {
      const url = window.URL.createObjectURL(downloadDialog.blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = downloadDialog.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }

    dispatch({ type: "RESET" });
  };

  const handleCloseDialog = useCallback(() => dispatch({ type: "SET_OPEN", payload: false }), []);

  useEffect(() => {
    fetchReportTypesData();
    // fetchDataConsumptionViewData();
    getCustomerData();
  }, []);

  const handleSelectionChange = (event) => {
    const selectedValue = event.target.value;
    // console.log("selectedValue:", selectedValue);
    setCurrentView(selectedValue);
  };

  const getViewLabelWithMonth = (view) => {
    const date = new Date();
    if (view === 'thismonth') {
      const monthName = date.toLocaleString('default', { month: 'long', year: 'numeric' });
      // return `This Month (${monthName})`;
      return monthName;
    } else if (view === 'lastmonth') {
      date.setMonth(date.getMonth() - 1);
      const monthName = date.toLocaleString('default', { month: 'long', year: 'numeric' });
      // return `Last Month (${monthName})`;
      return monthName;
    } else if (view === 'all') {
      return 'All';
    }

    return 'Select Period';
  };


  return (
          <>
            <Box sx={{ width: "50%", marginLeft: 2, marginBottom: 2, display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 600, marginTop: '4px', marginBottom: '6px', whiteSpace: "nowrap" }}> Search Customer Name : </Typography>
              <Select id="customerId" name="customerId" 
              value={selectedCustomer != null ? selectedCustomer.org_name : ""} 
              onChange={handleCustomerChange} 
              displayEmpty 
              fullWidth 
              sx={{ '.MuiSelect-select': { paddingTop: '8px !important', paddingBottom: '8px !important', minHeight: '35px !important', display: 'flex', alignItems: 'center', fontSize: '1em !important' }}} >
              {/* Default Option */}
              <MenuItem value="">
                <em>Select Customer</em>
              </MenuItem>

              {custDataList && custDataList.length > 0 &&
                custDataList.map((customer) => (
                  <MenuItem
                    key={customer.customer_id}
                    value={customer.org_name}
                  >
                    {customer.org_name}
                  </MenuItem>
                ))
              }
            </Select>
            </Box>
            <Box sx={{ flexGrow: 1, mt: 3 }}>
              <Card sx={{ position: 'relative', minHeight: 300 }}>
                <CardContent sx={{ p: 2 }}>

                  {loading && selectedCustomer && (
                    <Box
                      sx={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: secondary.main,
                        zIndex: 10,
                        borderRadius: 1,
                      }}
                    >
                      <CircularProgress color="secondary" size={40} />
                    </Box>
                  )}


                  {/* {!loading && ( */}
                    
                    <>
                      {/* <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 1 }}>
                        Data Consumption Summary
                      </Typography> */}
                      {/* <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400, mb: 1 }}>
                        Customer Name:&nbsp;{ dataConsumptionInfo && dataConsumptionInfo.org_name || selectedCustomer && selectedCustomer.org_name || "-" }
                      </Typography> */}
                      <Box sx={{ display: 'flex', gap: 2, p: 0.5, pb:2, pl: 0, pr: 0, justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gap: 2, }}>
                          <FormControl size="medium" sx={{ minWidth: 150 }}>
                            <Select
                              value={currentView}
                              onChange={handleSelectionChange}
                              disabled={loading}
                              sx={{
                                '& .MuiSelect-select': {
                                  paddingTop: '8px !important',
                                  paddingBottom: '8px !important',
                                  minHeight: '30px !important',
                                  display: 'flex',
                                  alignItems: 'center',
                                  py: 1,
                                  fontSize: '0.875rem !important'
                                },
                                '& .MuiSvgIcon-root': {
                                  width: 22,
                                  height: 22,
                                  top: 10,
                                }
                              }}
                            >
                              {reportTypes.map((item, index) => (
                                <MenuItem key={`timePeriods${index}`} value={item}>
                                  {getDisplayLabel(item)}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <Button
                            onClick={() => selectedCustomer && fetchDataConsumptionViewData( selectedCustomer.customer_id, currentView )}
                            variant="contained"
                            sx={{
                              '&:hover': {
                                backgroundColor: secondary.main,
                              },
                            }}
                            color="secondary"
                            size="medium"
                            startIcon={<RefreshIcon />}
                            // disabled={!DataConsumptionList || DataConsumptionList.length === 0 && loading}
                            disabled={!selectedCustomer}
                          >
                            {loading ? 'fetching...' : 'Fetch Data'}
                          </Button>

                          <Button
                            onClick={downloadReport}
                            variant='contained'
                            color="secondary"
                            size="medium"
                            startIcon={<DownloadIcon sx={{
                              color: (!DataConsumptionList || DataConsumptionList.length === 0)
                                ? 'secondary.main'
                                : 'inherit'
                            }} />}
                            disabled={!DataConsumptionList || DataConsumptionList.length === 0}
                          >
                            {downloading ? 'Downloading...' : 'Download Report'}
                          </Button>
                        </Box>
                        <Box sx={{ display: 'flex' }}>
                          <Chip
                            label={getViewLabelWithMonth(displayedView)}
                            color="secondary"
                            variant="outlined"
                            size="medium"
                            sx={{
                              '& .MuiChip-label': {
                                fontSize: '1rem',
                                fontWeight: 600
                              }
                            }}
                          />
                        </Box>
                      </Box>

                      <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                          <Grid container spacing={1} alignItems="center">
                            <Grid item xs={5}>
                              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                                Total Streaming Duration:
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <TextField
                                fullWidth
                                value={(probeStreamingInfo && probeStreamingInfo.total_streaming_duration) ?? "-"}
                                InputProps={{ readOnly: true, sx: { color: text.main } }}
                                sx={{ backgroundColor: transparent.main, borderRadius: borderRadius.md }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Grid container spacing={1} alignItems="center">
                            <Grid item xs={5}>
                              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                                Effective Number of Probes:
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <TextField
                                fullWidth
                                value={
                                  Array.isArray(probeStreamingInfo && probeStreamingInfo.probe_serial_numbers)
                                    ? probeStreamingInfo.probe_serial_numbers.length
                                    : "-"
                                }
                                InputProps={{ readOnly: true, sx: { color: text.main } }}
                                sx={{ backgroundColor: transparent.main, borderRadius: borderRadius.md }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Grid container spacing={1} alignItems="center">
                            <Grid item xs={5}>
                              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                                Total Viewer Duration:
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <TextField
                                fullWidth
                                value={(probeViewerInfo && probeViewerInfo.total_viewer_duration) ?? "-"}
                                InputProps={{ readOnly: true, sx: { color: text.main } }}
                                sx={{ backgroundColor: transparent.main, borderRadius: borderRadius.md }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Grid container spacing={1} alignItems="center">
                            <Grid item xs={5}>
                              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                                Effective Number of Viewers:
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <TextField
                                fullWidth
                                value={(probeViewerInfo && probeViewerInfo.total_unique_viewers) ?? "-"}
                                InputProps={{ readOnly: true, sx: { color: text.main } }}
                                sx={{ backgroundColor: transparent.main, borderRadius: borderRadius.md }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Divider flexItem sx={{ borderColor: primary.light, my: 1 }} />

                        <Grid item xs={12} md={6}>
                          <Grid container spacing={1} alignItems="center">
                            <Grid item xs={5}>
                              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                                Data Consumed - Probes:
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <TextField
                                fullWidth
                                value={(dataConsumptionInfo && dataConsumptionInfo.pretty_publisher_bytes_transferred) ?? "-"}
                                InputProps={{ readOnly: true, sx: { color: text.main } }}
                                sx={{ backgroundColor: transparent.main, borderRadius: borderRadius.md }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Grid container spacing={1} alignItems="center">
                            <Grid item xs={5}>
                              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                                Data Consumed - Viewers:
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <TextField
                                fullWidth
                                value={(dataConsumptionInfo && dataConsumptionInfo.pretty_viewer_bytes_transferred) ?? "-"}
                                InputProps={{ readOnly: true, sx: { color: text.main } }}
                                sx={{ backgroundColor: transparent.main, borderRadius: borderRadius.md }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Grid container spacing={1} alignItems="center">
                            <Grid item xs={5}>
                              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                                Total Data Consumed:
                              </Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <TextField
                                fullWidth
                                value={(dataConsumptionInfo && dataConsumptionInfo.pretty_total_bytes_transferred) ?? "-"}
                                InputProps={{ readOnly: true, sx: { color: text.main } }}
                                sx={{ backgroundColor: transparent.main, borderRadius: borderRadius.md }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  {/* )} */}

                </CardContent>
              </Card>
              <Dialog
                open={downloadDialog.open}
                onClose={handleCloseDialog}
                maxWidth="sm"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                  '& .MuiDialog-paper': {
                    backgroundColor: primary.main,
                  }
                }}
                fullWidth
              >

                <DialogTitle id="alert-dialog-title">
                  <Typography fontSize={size.lg} color={secondary.main} sx={{ fontWeight: 600, }}>{'Confirm Download'}</Typography>
                </DialogTitle>

                <DialogContent>
                  <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Filename</Typography>
                  <TextField
                    type="text"
                    fullWidth
                    focused={false}
                    value={downloadDialog.filename}
                    onChange={handleFilenameChange}
                    sx={{
                      color: text.main,
                      backgroundColor: transparent.main,
                      borderRadius: borderRadius.md,
                    }}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleCloseDialog}
                    variant="contained" color="secondary">
                    Cancel
                  </Button>
                  <Button
                    onClick={handleConfirmDownload}
                    color="secondary"
                    variant="contained"
                    disabled={!downloadDialog.filename.trim()}
                  >
                    Download
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </>
        );
}